import * as React from "react";
import { InputNumber, Row, Col } from "antd";
import styled, { ThemedStyledProps } from "styled-components";
import { InputNumberProps } from "antd/lib/input-number";

const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  line-height: 32px;
  font-weight: 300;
`;

type StyledInputProps = ThemedStyledProps<
  InputNumberProps & React.RefAttributes<InputNumber>,
  any
> & {
  hasError: boolean;
};

const StyledInput = styled(InputNumber)`
  height: 40px !important;
  width: 100% !important;
  background-color: #f2f2f2 !important;
  border:   ${(props: StyledInputProps) =>
    props.hasError ? "1px solid #eb0333 !important" : "none !important"}
  font-size: 14px !important;
  line-height: 32px !important;
  color: ${(props: StyledInputProps) =>
    props.disabled ? "#cfcfcf !important" : "#386ee8 !important;"}
  font-weight: 300 !important;
  &::placeholder {
    color: #386ee8 !important;
    font-weight: 300 !important;
  }
  .ant-input-number-handler-wrap {
      display: none;
  }
  input {
      height: 38px !important;
  }
`;

type Props = {
  label: string;
  placeholder?: string;
  value?: number;
  min?: number;
  max?: number;
  hasError?: boolean;
  disabled?: boolean;
  onChange: (value: number | undefined) => void;
};

export class ForwardNumberInput extends React.Component<Props> {
  render() {
    return (
      <Row type="flex">
        <Col span={24}>
          <Label>{this.props.label}</Label>
        </Col>
        <Col span={24}>
          <StyledInput
            placeholder={this.props.placeholder}
            min={this.props.min}
            max={this.props.max}
            value={this.props.value}
            onChange={this.props.onChange}
            hasError={this.props.hasError || false}
            onKeyDown={handleKeyDown}
            disabled={this.props.disabled}
          />
        </Col>
      </Row>
    );
  }
}

const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const characterCode = e.key;
  if (
    characterCode === "Backspace" ||
    characterCode === "ArrowRight" ||
    characterCode === "ArrowLeft" ||
    characterCode === "Delete" ||
    characterCode === "Tab"
  )
    return;

  const characterNumber = Number(characterCode);
  if (characterNumber >= 0 && characterNumber <= 9) {
    if (e.currentTarget.value && e.currentTarget.value.length) {
      return;
    } else if (characterNumber === 0) {
      e.preventDefault();
    }
  } else {
    e.preventDefault();
  }
};
